import { render, staticRenderFns } from "./DessertPage.vue?vue&type=template&id=0378b95d&scoped=true&"
import script from "./DessertPage.vue?vue&type=script&lang=js&"
export * from "./DessertPage.vue?vue&type=script&lang=js&"
import style0 from "./DessertPage.vue?vue&type=style&index=0&id=0378b95d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0378b95d",
  null
  
)

export default component.exports